<div class="wrapper">
  <div class="top" [ngClass]="topColor"></div>
  <div class="image" [ngClass]="imageIcon"></div>
  <div class="body">
    <div class="title">{{ title }}</div>
    <div class="description">{{ description }}</div>
  </div>
</div>
